export class TranslationSerializer {

    private static INSTANCE = new TranslationSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeTranslations(payload: any) {
        const translationLabels = payload.translationLabels || {};
        return translationLabels;
    }

}

export const translationSerializer = TranslationSerializer.instance;
